import { render } from "./ItemDeTexto.vue?vue&type=template&id=39dd6c30&ts=true"
import script from "./ItemDeTexto.vue?vue&type=script&lang=ts"
export * from "./ItemDeTexto.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__